import { render, staticRenderFns } from "./HoverTip.vue?vue&type=template&id=53646090&scoped=true"
import script from "./HoverTip.vue?vue&type=script&lang=ts"
export * from "./HoverTip.vue?vue&type=script&lang=ts"
import style0 from "./HoverTip.vue?vue&type=style&index=0&id=53646090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53646090",
  null
  
)

export default component.exports